import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/grid";
import { Navigation, Grid } from "swiper/modules";
import { viewPartners } from "../../states/actions/partnersAction";
import { useDispatch, useSelector } from "react-redux";
import BaseUrl from "../../service/API/base_url";

const Partners = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const partners = useSelector((state) => state.partners);
  // console.log("partners: ", partners);
  // use effect
  useEffect(() => {
    dispatch(viewPartners());
  }, []);

  const apiPartners =
    partners?.partners?.map((p) => `${BaseUrl}${p.photo}`) || [];

  const marqueeLogos = [...apiPartners];

  return (
    <section className="py-16 bg-white">
      {/* Heading */}
      <h2 className="text-center text-4xl font-bold text-gray-300 mb-12">
        OUR PARTNERS
      </h2>

      {/* Slider */}
      <div className="max-w-6xl mx-auto px-6">
        <div className="mt-12 relative overflow-hidden">
          <div className="flex gap-16 animate-marquee whitespace-nowrap">
            {marqueeLogos.map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt="Partner Logo"
                className="w-32 object-contain"
              />
            ))}
          </div>
        </div>

        <style>
          {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .animate-marquee {
            display: flex;
            width: max-content;
            animation: marquee 20s linear infinite;
          }
        `}
        </style>
      </div>

      {/* Button */}
      <div className="text-center mt-12">
        <a
          href={`https://t.me/aderawaddisu`}
          className="px-6 py-3 bg-[#C9A227] text-white font-semibold rounded-md shadow hover:bg-[#755542] transition"
        >
          Become a partner
        </a>
      </div>
    </section>
  );
};

export default Partners;
